@if (routerLink) {
  <a [routerLink]="routerLink"
     class="work-link--dark work-link__animated-icon flex gap-8">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
} @else {
  <a [href]="htmlLink"
     [target]="htmlLinkOpenInNewTab ? '_blank' : ''"
     class="work-link--dark work-link__animated-icon flex gap-8 margin-top-16">
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
}


<ng-template #linkContent>
  <span class="work-link--underlined">{{ text }}</span>
  <work-ui-icon name="arrow_right_alt" />
</ng-template>


<!-- todo refactoring -->
<!--
<a [routerLink]="routerLink || null"
   [href]="!routerLink ? htmlLink : null"
   [target]="!routerLink && htmlLinkOpenInNewTab ? '_blank' : ''"
   [ngClass]="{'margin-top-16': !routerLink}"
   class="work-link--dark work-link__animated-icon flex gap-8">
  <ng-container *ngTemplateOutlet="linkContent" />
</a>
-->
